var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "icon-menu",
      class: _vm.computedClass,
      style: _vm.componentStyle,
      on: { click: _vm.handleClick }
    },
    [
      _c("div", { staticClass: "menu-line", style: _vm.lineStyle }),
      _c("div", { staticClass: "menu-line", style: _vm.lineStyle }),
      _c("div", { staticClass: "menu-line", style: _vm.lineStyle }),
      _c("div", { staticClass: "menu-line", style: _vm.lineStyle }),
      _c("div", { staticClass: "menu-line", style: _vm.lineStyle }),
      _c("div", { staticClass: "menu-line", style: _vm.lineStyle }),
      _c("div", { staticClass: "menu-line", style: _vm.lineStyle })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }